<template>
  <dashboard-widget title="DISTILLING RATE" :zoomed="zoomed" :width="width" :enableDelete="enableDelete"
                      @zoom="$emit('zoom','DashboardDistillationSummary')"
                      @delete="$emit('delete','DashboardDistillationSummary')"
                      @close="$emit('close')"
                      xprint @print="print">
    <v-btn-toggle v-model="period" mandatory @change="refresh" style="position:absolute;top:40px;left:10px" :style="zoomed?'top:60px':''">
      <v-btn x-small value="Last30Days">Last 30 days</v-btn>
      <v-btn x-small value="Monthly">This month</v-btn>
    </v-btn-toggle>
    <v-btn-toggle v-model="view" mandatory @change="draw" style="position:absolute;top:40px;right:10px" :style="zoomed?'top:60px':''">
      <v-btn x-small>Total</v-btn>
      <v-btn x-small>Net</v-btn>
    </v-btn-toggle>
    <div class="text-center">
      <div ref="chart" class="d-inline-block" :style="zoomed?'height:420px;width:420px;margin-top:35px':'height:245px;width:245px;margin-top:25px'"
            @click="disableTo ? '' : $router.push({name:'ProductionDistilling'})"/>
    </div>
  </dashboard-widget>
</template>

<script>
import {format,add} from 'date-fns'
import printHtml from '@/mixins/printHtml'

export default {
  name: 'DashboardDistillationSummary',
  mixins: [printHtml],
  props: {
    from: {type:String, required:true},
    to: {type:String, required:true},
    zoomed: {type:Boolean, required:false, default:false},
    width: {type:Number, required:false, default:290},
    enableDelete: {type: Boolean, required:false, default:false},
    disableTo: {type: Boolean, required:false, default:false}
  },
  data() {
    return {
      view: 0,
      maxNet: 0,
      maxTotal: 0,
      dataGaugeNet: null,
      dataGaugeTotal: null,
      period: 'Last30Days',

      chart: null,
      options: {minorTicks:5}
    }
  },
  watch: {
    from() {
      this.refresh();
    },
    to() {
      this.refresh();
    }
  },
  async mounted() {
    if (window.google) {
      window.google.charts.load('current', {'packages':['gauge']});
      window.google.charts.setOnLoadCallback(() => {
        if (this.$refs.chart == undefined)
          return;
        this.chart = new window.google.visualization.Gauge(this.$refs.chart);
        this.refresh();
      });
    }
  },
  methods: {
    async refresh() {
      const results = await this.$apiCall(`query DashboardDistillationSummary($from:Date!, $to:Date!, $period:SummaryPeriod!) {
                                              distillationSummary(from:$from, to:$to, period:$period) {
                                                totalLAA,netLAA,periodStart
                                              }
                                          }`, {from:this.from, to:this.to, period:this.period});
      if (!results.error) {
        this.maxNet = 0;
        this.maxTotal = 0;
        for (const period of results.data.distillationSummary) {
          this.maxNet = this.maxNet > period.netLAA ? this.maxNet : period.netLAA;
          this.maxTotal = this.maxTotal > period.totalLAA ? this.maxTotal : period.totalLAA;
        }
        this.maxNet = Math.ceil(this.maxNet);
        if (this.maxNet == 0)
          this.maxNet = 1000;
        this.maxTotal = Math.ceil(this.maxTotal);
        if (this.maxTotal == 0)
          this.maxTotal = 1000;

        // Do data for gauge
        let n = results.data.distillationSummary.length-1;
        if (n !== -1 && results.data.distillationSummary[n].periodStart < format(add(new Date(), {days:-30}), 'yyyy-MM-dd'))
          n = -1;
        this.dataGaugeNet = [['Label','Value'],['LAA',n===-1?0:results.data.distillationSummary[n].netLAA]];
        this.dataGaugeTotal = [['Label','Value'],['LAA',n===-1?0:results.data.distillationSummary[n].totalLAA]];

        this.draw();
      }
    },
    draw() {
      if (this.chart === null)
        return;

      const formatter = new window.google.visualization.NumberFormat({fractionDigits: 1});
      const data = window.google.visualization.arrayToDataTable(this.view === 0 ? this.dataGaugeTotal : this.dataGaugeNet);
      formatter.format(data, 1);

      this.options.max = this.view === 0 ? this.maxTotal : this.maxNet;
      this.options.greenFrom = .9 * this.options.max;
      this.options.greenTo = this.options.max;
      this.options.yellowFrom = .75 * this.options.max;
      this.options.yellowTo = .9 * this.options.max;

      this.chart.draw(data, this.options);
    },
    print() {
      this.printHtml('',`<style>
                        @page {size:portrait}
                        body {font-family: Roboto, sans-serif; font-size:14px}
                        .title {font-weight:700;font-size:18px;text-align:center;width:100%}
                        .sub-title {text-align:center;margin-bottom:16px,width:100%}
                      </style>
                      <div class="title">Distilled</div>
                      <div class="sub-title">${this.$formatDate(this.from)} to ${this.$formatDate(this.to)}</div>
                      <img id="graph"/>`,
                      {id:'graph', src:this.chart.getImageURI()});
    }
  }
}
</script>